import { forwardRef, useContext, useRef } from 'react';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';

import { Button } from '@mui/material';
import { blue, grey } from '@mui/material/colors';
import { ConfigurationContext } from 'components/provider/OrginazationContext';
import { BiPrinter } from 'react-icons/bi';
import { ICourseRoster } from 'redux/reducers/user/dashboard';
import { formatTime } from 'utils/date';

const RoutineSchedule = forwardRef<HTMLDivElement, { rosterInfo: ICourseRoster }>(
  ({ rosterInfo }, ref) => {
    const dailySessionDateList = rosterInfo?.routine_sessions?.flatMap((s) =>
      s.daily_sessions.map((ds) => ds.routine_date)
    );
    const uniqueSessionDateList = Array.from(new Set(dailySessionDateList));

    const {appConfig}=useContext(ConfigurationContext)

    return (
      <div ref={ref}>
        <div id="schedule" style={{ backgroundColor: 'white', padding: 8 }}>
          <div id="header">
            <table style={{ width: '100%', textAlign: 'center' }}>
              <tr>
                <td>
                  <h1>{appConfig?.title}</h1>
                </td>
              </tr>
              {/* <tr>
              <td>
                <h2>Public Service Training Department</h2>
              </td>
            </tr> */}
              <tr>
                <td>
                  <h3>Training On</h3>
                </td>
              </tr>
              <tr>
                <td>
                  <h1 style={{ color: blue[500] }}>{rosterInfo.training_name}</h1>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    {rosterInfo.start_date} – {rosterInfo.end_date}
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <h3>PROGRAMME SCHEDULE</h3>
                </td>
              </tr>
            </table>
          </div>
          <div id="detail">
            <table style={{ width: '95%', margin: 'auto' }}>
              <tr>
                <td>
                  <strong>Module:</strong>
                  <p style={{ display: 'inline-block', marginLeft: 8 }}>{rosterInfo.course}</p>
                </td>
                <td></td>
                <td>
                  <strong>Date:</strong>
                  <p style={{ display: 'inline-block', marginLeft: 8 }}>{rosterInfo.start_date}</p>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Module Coordinator:</strong>
                  <p style={{ display: 'inline-block', marginLeft: 8 }}>
                    {rosterInfo?.module_coordinator?.join(' / ')}
                  </p>
                </td>
                <td>
                  <strong>Coordinators:</strong>
                  <p style={{ display: 'inline-block', marginLeft: 8 }}>
                    {rosterInfo?.coordinators?.join(' / ')}
                  </p>
                </td>
                <td>
                  <strong>Room:</strong>
                  <p style={{ display: 'inline-block', marginLeft: 8 }}>
                    {rosterInfo.hall ?? 'N/A'}
                  </p>
                </td>
              </tr>
            </table>
          </div>
          <div id="body">
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ backgroundColor: blue[100] }}>
                  <th style={{ border: '1px solid black', padding: '4px 8px' }}>Date</th>
                  {rosterInfo.routine_sessions.map((session) => (
                    <th style={{ border: '1px solid black', padding: '4px 8px' }} key={session.id}>
                      <p>{session.session_name}</p>
                      <p>
                        {formatTime(session.start_time)} - {formatTime(session.end_time)}
                      </p>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {uniqueSessionDateList &&
                  uniqueSessionDateList?.map((date, i) => (
                    <tr key={date} style={i % 2 ? { backgroundColor: grey[200] } : {}}>
                      <td
                        style={{
                          border: '1px solid black',
                          padding: '4px 8px',
                          textAlign: 'center'
                        }}>
                        <p>{date}</p>
                        {/* <p>{new Date(date)}</p> */}
                      </td>
                      {rosterInfo.routine_sessions.map((session) => {
                        const hasDailySession = !!session.daily_sessions.filter(
                          (ds) => ds.routine_date === date
                        ).length;

                        return (
                          <td
                            key={session.id}
                            style={{
                              border: '1px solid black',
                              padding: '4px 8px',
                              verticalAlign: 'baseline'
                            }}>
                            {!hasDailySession
                              ? 'N/A'
                              : session.daily_sessions
                                  ?.filter((ds) => ds.routine_date === date)
                                  ?.map((ds, index) => (
                                    <div key={index}>
                                      {(ds.altered_start_time || ds.altered_end_time) && (
                                        <p>
                                          <strong>
                                            {ds.altered_start_time!='00:00:00'? formatTime(ds.altered_start_time ?? ''):''}
                                            {ds.altered_end_time!='00:00:00'?formatTime(ds.altered_end_time):''}
                                          </strong>
                                        </p>
                                      )}

                                      <p>
                                        <strong>{ds.course_topic}</strong>
                                      </p>

                                      <div>
                                        {ds?.lecturers?.map((l) => (
                                          <p key={l} style={{ marginLeft: 8 }}>
                                            - {l}
                                          </p>
                                        ))}
                                      </div>
                                    </div>
                                  ))}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
);

const PrintableSchedule = ({ rosterInfo }: { rosterInfo: any }) => {
  const ref = useRef<HTMLDivElement | null>(null);

  return (
    <div>
      <ReactToPrint
        content={() => ref.current}
        pageStyle={`
            @page {
                background: white;
                margin: 10mm 10mm 10mm 10mm;  
            }
            html, body {
                background: white !important;
            }
        `}>
        <PrintContextConsumer>
          {({ handlePrint }) => (
            <div style={{ margin: '20px', float: 'right' }}>
              {' '}
              <Button variant="contained" onClick={handlePrint}>
                {/* <PrintIcon sx={{ mr: 1, width: 16 }} /> */}
                <BiPrinter />
                Print Schedule
              </Button>
            </div>
          )}
        </PrintContextConsumer>
      </ReactToPrint>

      <RoutineSchedule ref={ref} rosterInfo={rosterInfo} />
    </div>
  );
};

export default PrintableSchedule;

RoutineSchedule.displayName = 'RoutineSchedule';
